import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useSelector} from 'react-redux';
// slices
import { userSelector } from 'slices/user';


const RequireAuth = ({ children  }) => {
  const { isLogged } = useSelector(userSelector);
  const location = useLocation();

  if (isLogged) {
    return children;
  } else {
    return <Navigate to={`/intranet/login`} state={{ from: location }} />;
  }
};

export default RequireAuth;
